import { Injectable } from '@angular/core';
import { NavigationEnd, Event, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteHistoryService {
  private history: string[] = [];

  constructor(private router: Router) {
    this.router.events
      .pipe(
        filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd) // Filter and type-guard to NavigationEnd
      )
      .subscribe((event: NavigationEnd) => {
        this.history.push(event.urlAfterRedirects); // Safely access NavigationEnd-specific properties
      });
  }
  getHistory(): string[] {
    return this.history;
  }

  getPreviousUrl(): string | null {
    return this.history.length > 1 ? this.history[this.history.length - 2] : null;
  }
}
